import { useEffect } from "react";

import Hero from "../components/Hero";
import Why from "../components/Why";
import Features from "../components/Features";
import Visionaries from "../components/Visionaries";
import ScrollTop from "../features/ScrollTop";
import Shadow from "../components/Shadow";

function MainHome() {
  useEffect(() => {
    document.title =
      "AttnQ - Home | Get Real Estate Leads for Brokers and Investors";
  }, []);

  return (
    <main>
      <ScrollTop />
      <Hero />
      <Why />
      <Features />
      <Visionaries />
      <Shadow />
    </main>
  );
}

export default MainHome;
